const { handleError, handleResponse, api } = require("./baseApi");

const api_config = require("./api_config");

const EXTEND_URL = "groups/v1";

function getGroupMembershipsByEmailApi(email) {
    const encodedEmail = encodeURIComponent(email);
    return api
        .get(`${EXTEND_URL}/memberships?email=${encodedEmail}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getGroupMembershipsByEmailAndGroupReferenceApi(email, groupReference) {
    return api
        .get(`${EXTEND_URL}/memberships`, {
            params: {reference: groupReference,email},
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function createGroupApi(group_data) {
    return api
        .post(`${EXTEND_URL}`, JSON.stringify(group_data), {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}

function joinGroupByReferenceAndEmailApi(membership_data) {
    return api
        .post(`${EXTEND_URL}/memberships`, JSON.stringify(membership_data), {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getGroupByReferenceApi(reference) {
    return api
        .get(`${EXTEND_URL}/?reference=${reference}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getGroupByIdApi(groupId) {
    return api
        .get(`${EXTEND_URL}/${groupId}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function updateGroupByReferenceApi(group) {
    return api
        .put(`${EXTEND_URL}/?reference=${group.reference}`, JSON.stringify(group), {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function deleteGroupMemberByUserId(userId, groupReference) {
    return api
        .delete(`${EXTEND_URL}/memberships/user/${userId}`, {
            params: {reference: groupReference},
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

module.exports = {
    getGroupMembershipsByEmailApi,
    createGroupApi,
    getGroupByReferenceApi,
    getGroupByIdApi,
    joinGroupByReferenceAndEmailApi,
    updateGroupByReferenceApi,
    deleteGroupMemberByUserId,
    getGroupMembershipsByEmailAndGroupReferenceApi
};
